
import { useState, useEffect, ReactNode, FC } from 'react';

interface SafeComponentWrapperProps {
  children: ReactNode;
  fallback?: ReactNode;
  componentName?: string;
}

export const SafeComponentWrapper: FC<SafeComponentWrapperProps> = ({
  children, 
  fallback = null,
  componentName = 'Component'
}) => {
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    console.log(`${componentName} SafeComponentWrapper initialized`);
  }, [componentName]);

  if (hasError) {
    console.warn(`${componentName} disabled due to error`);
    return <>{fallback}</>;
  }

  return <>{children}</>;
};
